export default ({ to, from, next }) => {
    if ((localStorage.getItem('toaomt_admin') != null || localStorage.getItem('toaomt_admin') != undefined) &&
        (localStorage.getItem('toaomt_token') != null || localStorage.getItem('toaomt_token') != undefined)) {
        const toaomt_admin = localStorage.getItem('toaomt_admin');
        var CryptoJS = require("crypto-js");
        const decryptData = CryptoJS.AES.decrypt(toaomt_admin, process.env.VUE_APP_CRYPTO_SECRETKEY_key).toString(CryptoJS.enc.Utf8);
        if(decryptData == undefined || decryptData == null || decryptData == "undefined"){
            window.location.href = "/login";
        }
        if (decryptData != process.env.VUE_APP_IS_ADMIN) {
            window.location.href = "/login";
        }
    }else{
        window.location.href = "/login";
    }
}
